import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/tags/HistoryManageTags/.eu';
import Kr from '@di-shared/features/history/tags/HistoryManageTags/.kr';
import Na from '@di-shared/features/history/tags/HistoryManageTags/.na';

export interface HistoryManageTagsProps {
  vin: string;
}

export default function HistoryManageTags({vin}: HistoryManageTagsProps) {
  return (
    <>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
      <Environment.Na>
        <Na vin={vin} />
      </Environment.Na>
    </>
  );
}
